import { ArrowLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { PageSubHeaderBreadcrumbs } from '@/components/organisms/PageSubHeader';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { selectAccountSlug } from '@/redux/session/selectors';

interface ContactBreadcrumbsProps {
  contactName?: string;
}

export const ContactBreadcrumbs = ({ contactName }: ContactBreadcrumbsProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);
  const listPath = `/${slug}/contacts`;
  const name = contactName || t('contacts.unnamed');

  return (
    <PageSubHeaderBreadcrumbs>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <div className="flex items-center">
              <Link to={listPath}>
                <Button variant="ghost-neutral" size="icon-sm">
                  <ArrowLeftIcon size={16} className="text-muted-foreground" />
                </Button>
              </Link>
              <div className="mr-4 ml-2 h-4 w-px bg-border" />
              <BreadcrumbLink asChild>
                <Link to={listPath} className="breadcrumb-link">
                  {t('contacts.title')}
                </Link>
              </BreadcrumbLink>
            </div>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>{name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </PageSubHeaderBreadcrumbs>
  );
};
